export const GETTING_CSRF_TOKEN = 'GETTING_CSRF_TOKEN';
export const GETTING_USER_BY_ID = 'GETTING_USER_BY_ID';
export const GETTING_USER_BY_EMAIL = 'GETTING_USER_BY_EMAIL';
export const SET_CSRF_TOKEN = 'SET_CSRF_TOKEN';

export const SIGNING_UP_USER = 'SIGNING_UP_USER';
export const SIGN_UP_USER = 'SIGN_UP_USER';

export const SENDING_EMAIL_RATES = 'SENDING_EMAIL_RATES';
export const EMAIL_RATES_SENT = 'EMAIL_RATES_SENT';
export const SENDING_RATES_ERROR = 'SENDING_RATES_ERROR';

export const CLEAR_SIGN_UP_ERROR_MESSAGE = 'CLEAR_SIGN_UP_ERROR_MESSAGE';
export const SIGN_UP_ERROR = 'SIGN_UP_ERROR';

export const LOGIN_USER = 'LOGIN_USER';
export const LOGGED_IN_USER = 'LOGGED_IN_USER';

export const PATCH_UPDATE_USER = 'PATCH_UPDATE_USER';

export const SET_USER_INFO = 'SET_USER_INFO';

export const LOGGED_IN_ERROR = 'LOGGED_IN_ERROR';
export const CLEAR_LOGGED_IN_ERROR_MESSAGE = 'CLEAR_LOGGED_IN_ERROR_MESSAGE';

export const LOGOUT_USER = 'LOGOUT_USER';

export const FORGET_PASSWORD = 'FORGET_PASSWORD';

export const RESET_PASSWORD = 'RESET_PASSWORD';

export const TOKEN = 'TOKEN';

export const HANDLE_AUTH_CALLBACK = 'HANDLE_AUTH_CALLBACK';

export const GOOGLE_LOGGED_IN_USER = 'GOOGLE_LOGGED_IN_USER';

export const FACEBOOK_LOGGED_IN_USER = 'FACEBOOK_LOGGED_IN_USER';

// VEHICLE INFO
export const GETTING_VEHICLE_MAKE_AND_MODEL = 'GETTING_VEHICLE_MAKE_AND_MODEL';
export const VEHICLE_MODEL_INFO = 'VEHICLE_MODEL_INFO';

export const GET_VEHICLE_MODEL_INFO = 'GET_VEHICLE_MODEL_INFO';

export const UPDATE_VEHICLE_INFO = 'UPDATE_VEHICLE_INFO';
export const UPDATE_PROPERTY_INFO = 'Update_Property_Info';

// PROPERTY INFO
export const GETTING_PROPERTY_OCCUPANCY_INFO = 'GETTING_PROPERTY_OCCUPANCY_INFO';

// EMPLOYMENT INFO
export const GETTING_USER_EMPLOYMENT_INFO = 'GETTING_USER_EMPLOYMENT_INFO';
export const CREATING_USER_EMPLOYMENT_INFO = 'CREATING_USER_EMPLOYMENT_INFO';
export const UPDATE_USER_EMPLOYMENT_INFO = 'UPDATE_USER_EMPLOYMENT_INFO';
export const PATCHING_USER_EMPLOYMENT_INFO = 'PATCHING_USER_EMPLOYMENT_INFO';

// RESIDENCY INFO
export const GETTING_USER_RESIDENCY_INFO = 'GETTING_USER_RESIDENCY_INFO';
export const CREATING_USER_RESIDENCY_INFO = 'CREATING_USER_RESIDENCY_INFO';
export const UPDATE_USER_RESIDENCY_INFO = 'UPDATE_USER_RESIDENCY_INFO';
export const PATCHING_USER_RESIDENCY_INFO = 'PATCHING_USER_RESIDENCY_INFO';

// ASSETS AND NET WORTH INFO
export const GETTING_USER_ASSET_INFO = 'GETTING_USER_ASSET_INFO';
export const CREATING_USER_ASSET_LIABILITY_INFO = 'CREATING_USER_ASSET_LIABILITY_INFO';
export const UPDATING_USER_ASSET_LIABILITY_INFO = 'UPDATING_USER_ASSET_LIABILITY_INFO';
export const UPDATE_ASSETS_AND_NET_WORTH_INFO = 'UPDATE_ASSETS_AND_NET_WORTH_INFO';

export const GETTING_USER_LIABILITY_INFO = 'GETTING_USER_LIABILITY_INFO';
export const UPDATE_LIABILITIES_NET_WORTH_INFO = 'UPDATE_LIABILITIES_NET_WORTH_INFO';

export const CHECKING_RATES = 'CHECKING_RATES';

export const POST_FILTER_RATES = 'POST_FILTER_RATES';

// PARTNER CONTACT
export const ADDING_PARTNER_CONTACT = 'ADDING_PARTNER_CONTACT';
export const ADD_PARTNER_CONTACT = 'ADD_PARTNER_CONTACT';

//CONTACT
export const ADD_CONTACT = 'ADD_CONTACT';

export const UPDATE_CONTACT = 'UPDATE_CONTACT';

export const FIND_CONTACT = 'FIND_CONTACT';

//SURVEYS
export const POST_SURVEY = 'POST_SURVEY';

export const SET_FILTERED_SURVEYS = 'SET_FILTERED_SURVEYS';

export const SET_COMPLETED_QUALIFIED_SURVEYS = 'SET_COMPLETED_QUALIFIED_SURVEYS';

// PARTNER FREE TRIALS
export const GETTING_FREE_TRIAL_REPORT = 'GETTING_FREE_TRIAL_REPORT';
export const UPDATE_FREE_TRIAL_REPORT_INFO = 'UPDATE_FREE_TRIAL_REPORT_INFO';

export const DOWNLOADING_FREE_TRIAL_REPORT = 'DOWNLOADING_FREE_TRIAL_REPORT';

export const DOWNLOAD_PDF_SUCCESSFUL = 'DOWNLOAD PDF SUCCESSFUL';
export const CLOSE_DOWNLOAD_SUCCESS_TOASTER = 'CLOSE_DOWNLOAD_SUCCESS_TOASTER';
